var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTsunami(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    id: "tsunami",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 18,
    x2: 18,
    y1: 18,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aaa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 18,
    x2: 18,
    y1: 18,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c42a2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 18,
    x2: 18,
    y1: 29,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66321d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71321b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 20.95,
    x2: 20.95,
    y1: 37,
    y2: 51.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a84122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66321d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "f",
    x1: 20.95,
    x2: 20.95,
    y1: 40.71,
    y2: 51.51
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 43.24,
    x2: 43.24,
    y1: 5.42,
    y2: 54.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a1e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0017dd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 43.28,
    x2: 43.28,
    y1: 40.71,
    y2: 54.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0009bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007fe8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "h",
    x1: 32,
    x2: 32,
    y1: 42.71,
    y2: 58
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M26.6,24.2l-8-6a1,1,0,0,0-1.2,0l-8,6A1,1,0,0,0,9,25V38a1,1,0,0,0,1,1H26a1,1,0,0,0,1-1V25A1,1,0,0,0,26.6,24.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M30.6,27.2l-12-9a1,1,0,0,0-1.2,0l-12,9a1,1,0,0,0,1.2,1.6L18,20.25,29.4,28.8a1,1,0,0,0,.6.2,1,1,0,0,0,.8-.4A1,1,0,0,0,30.6,27.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 10,
    x: 14,
    y: 29,
    fill: "url(#a)",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M38.52,40.47A16.14,16.14,0,0,0,28.46,37H4a1,1,0,0,0-1,1V49.31a1,1,0,0,0,.84,1,84.55,84.55,0,0,0,13.31,1.21c11,0,18-3.2,21.63-9.77A1,1,0,0,0,38.52,40.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M38.78,41.74a1,1,0,0,0,0-.93,4.8,4.8,0,0,0-1.5.53A4.85,4.85,0,0,0,35,44.08l-4.08-2.59a4.94,4.94,0,0,0-2.66-.78,5,5,0,0,0-2.39.62,4.91,4.91,0,0,0-2.3,2.75l-4.08-2.59a5,5,0,0,0-7.35,2.59L8.05,41.49a4.93,4.93,0,0,0-2.66-.77A4.86,4.86,0,0,0,3,41.36v8a1,1,0,0,0,.84,1,84.55,84.55,0,0,0,13.31,1.21C28.14,51.51,35.14,48.31,38.78,41.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M60.37,26.4C58.19,17.29,51,10.81,45,7.79c-4.85-2.45-9.57-3-12.95-1.6-4.05,1.71-7.74,7-6.26,10.89a8.16,8.16,0,0,0,5.6,4.48,5.66,5.66,0,0,0,5.19-.87,6.17,6.17,0,0,0,1.7-5.4,12.88,12.88,0,0,1,3,2.42C46.45,23.37,44.2,31.17,43.93,32c-1.83,5.83-6.69,8.72-9.42,9.92-.7.31-1.24.5-1.51.6l-.19.07a13.71,13.71,0,0,1-3.3.61,1,1,0,0,0-.77,1.52c3.65,5.91,7.58,9.05,12,9.6a11.44,11.44,0,0,0,1.43.09c4.37,0,9-2.45,14.22-7.46a.83.83,0,0,0,.16-.21C58.88,42.9,62.45,35.1,60.37,26.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M39.68,40.71a4.93,4.93,0,0,0-2.39.63A4.85,4.85,0,0,0,35,44.08l-2.25-1.43a13.58,13.58,0,0,1-3.23.59,1,1,0,0,0-.77,1.52c3.65,5.91,7.58,9.05,12,9.6a11.44,11.44,0,0,0,1.43.09c4.37,0,9-2.45,14.22-7.46a.83.83,0,0,0,.16-.21c.44-.74.93-1.62,1.41-2.62l-4.2-2.67a5,5,0,0,0-2.66-.78,5.07,5.07,0,0,0-2.4.62,4.89,4.89,0,0,0-2.29,2.75l-4.08-2.59A5,5,0,0,0,39.68,40.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M60.39,46.25a1,1,0,0,0-1.09.21,1,1,0,0,1-1.21.14L52.7,43.18a2.93,2.93,0,0,0-3-.09,3,3,0,0,0-1.54,2.69,1,1,0,0,1-1.48.82l-4.79-3-.6-.39a2.93,2.93,0,0,0-3-.09,3,3,0,0,0-1.54,2.69.94.94,0,0,1-.5.85,1,1,0,0,1-1,0l-5.39-3.42a2.93,2.93,0,0,0-3-.09,3,3,0,0,0-1.53,2.69.94.94,0,0,1-.5.85,1,1,0,0,1-1,0l-5.39-3.42a2.93,2.93,0,0,0-3-.09,3,3,0,0,0-1.53,2.69,1,1,0,0,1-1.48.82L7,43.18a3,3,0,0,0-3.69.41A1,1,0,0,0,3,44.3V57a1,1,0,0,0,1,1H60a1,1,0,0,0,1-1V47.17A1,1,0,0,0,60.39,46.25Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTsunami);
export default __webpack_public_path__ + "static/media/tsunami.6dd44f6a5a9d07e8c11f60aa4056f543.svg";
export { ForwardRef as ReactComponent };